import { useState } from "react";
import { Info, Globe2, KeyRound, Wrench, Factory, Sparkles, Activity } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { COPPER } from "./VestaAuth";

const VOCI = [
  [Globe2, "Vesta World", "Il social network privato della rete Torri: post, messaggi, profili e lavori realizzati dei partner."],
  [KeyRound, "Tools commerciali", "Configuratori e strumenti per offrire al cliente finale un'esperienza completa, dal preventivo alla proposta."],
  [Wrench, "Tools tecnici", "Calcoli, schede e strumenti per studiare e preparare il cantiere."],
  [Factory, "Backoffice con la fabbrica", "Listino riservato, commesse, preventivi e magazzino in collegamento diretto con Torri."],
  [Activity, "Torri Monitoring", "Gli impianti dei tuoi clienti in tempo reale, con analisi AI di produzione, consumi e allarmi."],
  [Sparkles, "My Vesta", "Il tuo profilo, i Punti Vesta, il Catalogo Vesta e la tua pagina su torri.solar."],
];

export default function VestaInfo() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="vesta-info-btn"
        className="inline-flex items-center gap-1 text-[11px] font-medium normal-case tracking-normal text-neutral-500 transition-colors hover:text-[#E8B48F]">
        <Info className="h-3.5 w-3.5" />cosa è Vesta?
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[88vh] max-w-lg overflow-y-auto border-neutral-800 bg-neutral-950 text-white" data-testid="vesta-info-dialog" aria-describedby={undefined}>
          <DialogHeader><DialogTitle className="font-heading text-xl" style={{ color: COPPER }}>Cos'è Ai VESTA</DialogTitle></DialogHeader>
          <p className="text-sm leading-relaxed text-neutral-300">Ai VESTA è il motore di Ai sviluppato dall’azienda e riservato ai partner installatori Torri. In un unico posto trovi un sistema digitale di strumenti, dati e network per promuovere l’alta gamma e crescere insieme alla rete.</p>
          <div className="rounded-xl border border-[#C17F59]/30 bg-[#C17F59]/5 p-3" data-testid="vesta-info-nome">
            <div className="mb-1 text-[11px] font-bold uppercase tracking-widest" style={{ color: COPPER }}>Perché “Vesta”</div>
            <p className="text-xs leading-relaxed text-neutral-300">Il nome Vesta richiama una delle radici più antiche della cultura italiana: il fuoco custodito, simbolo di continuità, appartenenza e comunità. Un significato che abbiamo scelto per rappresentare una rete di professionisti e imprese che custodiscono il valore della tecnologia e del saper fare italiano.</p>
          </div>
          <div className="space-y-3 pt-1">
            {VOCI.map(([Icon, t, d]) => (
              <div key={t} className="flex gap-3">
                <Icon className="mt-0.5 h-5 w-5 shrink-0" style={{ color: COPPER }} />
                <div><div className="text-sm font-bold">{t}</div><div className="text-xs leading-relaxed text-neutral-400">{d}</div></div>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
